import getAuditTrailExportRequest from '@domain/model/request/auditTrail/getAuditTrailExportRequest';
import getAuditTrailExport from '@hooks/auditTrail/getAuditTrailExport';

const useGetAuditTrailExport = ({ payload, bulk = false }) => {
    const queries = getAuditTrailExportRequest({ payload, bulk });

    return getAuditTrailExport({ queries });
};

export default useGetAuditTrailExport;
